module.exports = __webpack_public_path__ + "static/media/mediametrieLogo.8260d717.svg";